// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react:true*/
import React, {useContext, useMemo} from 'react';
import cn from 'classnames';
import styles from './checkbox.module.less';
import Icon_check from '../img/hola2023/icons/8/check.svg';
import {Svg} from '../shared/svg';
import {Settings_context} from '../settings_ctx';

type t_checkbox_color = 'default'|'primary'|'grey';
type t_checkbox_size = 'sm'|'xs';
export interface i_checkbox_props<
    t_color = t_checkbox_color,
    t_size = t_checkbox_size,
    > {
    checked: boolean;
    on_change: (value:boolean)=>void;
    caption?: string|JSX.Element;
    size?: t_size;
    cls?: string;
    caption_cls?: string;
    light?: boolean;
    mode?: 'basic'|'toggle';
    icon?: JSX.Element;
    color?: t_color;
    disabled?: boolean;
}
export const Checkbox = <
    t_color extends string = t_checkbox_color,
    t_size extends string = t_checkbox_size,
    >(props:i_checkbox_props<t_color, t_size>)=>{
    const {theme_name} = useContext(Settings_context);
    const default_icon = useMemo(()=><Icon_check width={8} height={8}/>,
        [theme_name]);
    const {checked, on_change, caption, size, cls, caption_cls, light,
        mode='basic', color='default', disabled, icon = default_icon} = props;
    const cls_root = cn(styles.hola_checkbox, checked && styles.checked,
        size=='sm' && styles.hola_checkbox__sm,
        size=='xs' && styles.hola_checkbox__xs,
        color=='primary' && styles.hola_checkbox__color_primary,
        color=='grey' && styles.hola_checkbox__color_grey,
        disabled && styles.hola_checkbox__disabled,
        cls);
    return <label className={cls_root}>
      {mode=='basic' && <div className={styles.hola_checkbox__quad}>
        <Svg icon={icon} cls={styles.hola_checkbox__icon}/>
      </div>}
      {mode=='toggle' && <div className={styles.toggle} date-elem="toggle">
        <div className={styles.but} date-elem="but"></div>
      </div>}
      <input type="checkbox" checked={checked}
        onChange={()=>on_change(!checked)}/>
      {caption && <span className={cn(styles.hola_checkbox__caption,
        light && styles.hola_checkbox__caption__light, caption_cls)}>
        {caption}
      </span>}
    </label>;
};
